export const timeout = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const scheduleIdleTask = <T>(
  task: () => T,
  timeoutMs?: number,
): Promise<T> => {
  return new Promise((resolve, reject) => {
    const callback = () => {
      Promise.resolve(task()).then(resolve).catch(reject);
    };

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      window.requestIdleCallback(
        callback,
        timeoutMs ? { timeout: timeoutMs } : undefined,
      );
    } else {
      setTimeout(callback, 0);
    }
  });
};

// A waitable signal that can be triggered and reset. Uses AbortController under the hood.
// - wait() resolves immediately if triggered, otherwise blocks until trigger() is called
// - reset() returns the signal to a waiting state
export const makeResettableSignal = (isTriggered: boolean = false) => {
  let controller = new AbortController();
  if (isTriggered) {
    controller.abort();
  }
  return {
    trigger: () => controller.abort(),
    reset: () => {
      controller = new AbortController();
    },
    isTriggered: () => controller.signal.aborted,
    wait: async () => {
      await new Promise((resolve) => {
        if (controller.signal.aborted) {
          resolve(undefined);
          return;
        }
        controller.signal.addEventListener("abort", resolve);
      });
    },
  };
};
